import qs from "qs";
import axios from "axios";

const paramsSerializer = params =>
  qs.stringify(params, { arrayFormat: "repeat" });

class SuperCarersClient {
  static request(method, url, { params, data }) {
    const options = {
      url: SUPERCARERS_API_URL + url,
      paramsSerializer,
      method
    };

    if (params) {
      options.params = params;
    }

    if (data) {
      options.data = data;
    }

    return axios(options);
  }

  static get(url, params) {
    return SuperCarersClient.request("get", url, { params });
  }

  static delete(url, params) {
    return SuperCarersClient.request("delete", url, { params });
  }

  static post(url, data) {
    return SuperCarersClient.request("post", url, { data });
  }

  static put(url, data) {
    return SuperCarersClient.request("put", url, { data });
  }
}

export default SuperCarersClient;
